import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-example-pie-widget',
  templateUrl: './example-pie-widget.component.html',
  styleUrls: ['./example-pie-widget.component.scss']
})
export class ExamplePieWidgetComponent implements OnInit {

  data = [{
    country: 'USA',
    medals: 110
  }, {
    country: 'China',
    medals: 100
  }, {
    country: 'Russia',
    medals: 72
  }, {
    country: 'Britain',
    medals: 47
  }, {
    country: 'Australia',
    medals: 46
  }, {
    country: 'Germany',
    medals: 41
  }, {
    country: 'France',
    medals: 40
  }, {
    country: 'South Korea',
    medals: 31
  }];

  constructor() {
  }

  ngOnInit(): void {
  }

  customizeLabel(arg) {
    return arg.valueText; // + ' (' + arg.percentText + ')';
  }

}
